import { THEME_DARK } from "../constants";

export const setVariablesForBlock = (block, moduleTheme) => {
    const accentColor = hexToRGB(moduleTheme.accentColor);
    const darkColor = hexToRGB(moduleTheme.backgroundColor);
    const lightColor = hexToRGB(moduleTheme.textColor);

    const mailColor = moduleTheme.colorTheme === THEME_DARK ? 'dark' : 'light';

    block.style.setProperty('--app-accent-color', `rgb(${accentColor})`);
    block.style.setProperty('--app-color-dark', darkColor);
    block.style.setProperty('--app-color-light', lightColor);
    block.style.setProperty('--app-accent-color-2', `rgba(${accentColor}, .80)`);
    block.style.setProperty(
        '--app-text-color',
        `rgba(var(--app-color-${moduleTheme.colorTheme === THEME_DARK ? 'light' : 'dark'}))`
    );
    block.style.setProperty(
        '--app-text-color-1',
        `rgb(${lightColor})`
    );
    block.style.setProperty(
        '--app-color-0',
        `rgb(var(--app-color-${mailColor}))`
    );
    block.style.setProperty(
        '--app-color-1',
        `rgba(var(--app-color-light), .05)`
    );
    block.style.setProperty(
        '--app-color-2',
        `rgba(var(--app-color-light), ${moduleTheme.colorTheme === THEME_DARK ? '.10' : '.40'})`
    );
    block.style.setProperty(
        '--app-color-3',
        `rgba(var(--app-color-light), ${moduleTheme.colorTheme === THEME_DARK ? '.40' : '.80'})`
    );
    block.style.setProperty(
        '--app-color-4',
        `rgba(var(--app-color-light), ${moduleTheme.colorTheme === THEME_DARK ? '.80' : '.85'})`
    );
    block.style.setProperty(
        '--app-color-5',
        `rgba(var(--app-color-light), ${moduleTheme.colorTheme === THEME_DARK ? '.30' : '.40'})`
    );
    block.style.setProperty(
        '--app-color-6',
        `rgba(var(--app-color-light), ${moduleTheme.colorTheme === THEME_DARK ? '.10' : '.15'})`
    );

};

function hexToRGB(hex) {
    if (hex.length === 3) {
        hex = '' + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    
    const color = [
        parseInt(hex.substring(0, 2), 16),
        parseInt(hex.substring(2, 4), 16),
        parseInt(hex.substring(4, 6), 16),
    ];

    return color.join(', ');
}